import { render, staticRenderFns } from "./NbTextbox.vue?vue&type=template&id=efda4c14&scoped=true&"
import script from "./NbTextbox.vue?vue&type=script&lang=js&"
export * from "./NbTextbox.vue?vue&type=script&lang=js&"
import style0 from "./NbTextbox.vue?vue&type=style&index=0&id=efda4c14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efda4c14",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
